import { render, staticRenderFns } from "./demoproject-modal.vue?vue&type=template&id=4b9568e8"
import script from "./demoproject-modal.vue?vue&type=script&lang=js"
export * from "./demoproject-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports